var translations = {
    "All Groups": {
        "es": "Todos los grupos",
        "fr": "Tous les groupes",
    },
    "All Time": {
        "es": "Todo el tiempo",
        "fr": "Tout le temps",
    },
    "Almost Escaped": {
        "es": "Casi escapado",
        "fr": "Presque échappé",
    },
    "Group Photos": {
        "es": "Fotos Grupales",
        "fr": "Photos de Groupe",
    },
    "Groups of ": {
        "es": "Grupos de ",
        "fr": "Groupes de ",
    },
    "Last 30 Days": {
        "es": "Últimos 30 días",
        "fr": "30 jours",
    },
    "leaderboard": {
        "es": "tabla de clasificación",
        "fr": "classement",
    },
    "Nothing to see here...": {
        "es": "Nada que ver aqui...",
        "fr": "Rien à voir ici...",
    },
    "Share": {
        "es": "Compartir",
        "fr": "Partager",
    },
    "There are no entries on this leaderboard.": {
        "es": "No hay entradas en esta tabla de clasificación.",
        "fr": "Il n'y a aucune entrée dans ce classement.",
    },
    "Tweet": {
        "es": "Piar",
        "fr": "Tweet",
    },
}

export function translate(text, language) {
    if (language == 'en') {
        return text;
    } else {
        return translations[text][language];
    }
}
